import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSliceStyle } from '../../../../redux/slices/FJSliceTextToImage';
import FJTextToImageStyles from '../view/FJTextToImageStyles';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImageStylesContainer = memo(function FJTextToImageStylesContainer({ id }) {
    useLocalStore();
    const dispatch = useDispatch();
    const curStyle = useSelector(state => state.textToImage.curStyle);
    const styleList = useSelector(state => state.textToImage.styleList);

    const changeStyle = useCallback(
        style => {
            dispatch(setSliceStyle(style));
        },
        [dispatch],
    );

    return <FJTextToImageStyles curStyle={curStyle} changeStyle={changeStyle} styleList={styleList} id={id} />;
});

export default FJTextToImageStylesContainer;
